import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import './LoginPage.css';
import VERSION from '../version';

export default function EsqueciSenhaPage() {
  const [step, setStep] = useState(1); // 1: buscar usuário, 2: nova senha
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [userId, setUserId] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleBuscar(e) {
    e.preventDefault();
    setError('');
    if (!username.trim()) { setError('Informe seu nome de usuário.'); return; }
    setLoading(true);

    const email = username.trim().toLowerCase() + '@fincasa.app';
    const { data: profile } = await supabase
      .from('profiles')
      .select('id')
      .eq('email', email)
      .single();

    setLoading(false);
    if (!profile) {
      setError('Usuário não encontrado.');
      return;
    }

    setUserId(profile.id);
    setStep(2);
  }

  async function handleRedefinir(e) {
    e.preventDefault();
    setError('');
    if (password.length < 6) { setError('A senha deve ter pelo menos 6 caracteres.'); return; }
    if (password !== confirm) { setError('As senhas não coincidem.'); return; }
    setLoading(true);

    const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
    const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

    const res = await fetch(`${supabaseUrl}/functions/v1/create-user`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'apikey': anonKey,
        'Authorization': `Bearer ${anonKey}`,
      },
      body: JSON.stringify({ action: 'update', userId, password }),
    });

    const result = await res.json();
    setLoading(false);

    if (!res.ok) {
      setError(result.error || 'Erro ao redefinir senha.');
      return;
    }

    navigate('/login');
  }

  return (
    <div className="login-bg">
      <div className="login-glow" />
      <div className="login-card fade-in">
        <div className="login-logo">
          <span className="login-logo-icon">🔑</span>
          <div>
            <h1 className="login-title">Fincasa</h1>
            <p className="login-sub">
              {step === 1 ? 'Redefinir senha' : `Olá, ${username}!`}
            </p>
          </div>
        </div>

        {step === 1 && (
          <form onSubmit={handleBuscar} className="login-form">
            <div className="form-group">
              <label>Nome de Usuário</label>
              <input
                type="text"
                placeholder="seu usuário"
                value={username}
                onChange={e => setUsername(e.target.value)}
                required
                autoFocus
                autoCapitalize="none"
                autoCorrect="off"
              />
            </div>

            {error && <div className="alert alert-error">{error}</div>}

            <button className="btn btn-primary w-full login-btn" disabled={loading}>
              {loading ? <><span className="spinner" /> Buscando...</> : 'Continuar'}
            </button>
          </form>
        )}

        {step === 2 && (
          <form onSubmit={handleRedefinir} className="login-form">
            <div className="form-group">
              <label>Nova Senha</label>
              <input
                type="password"
                placeholder="Mínimo 6 caracteres"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                autoFocus
              />
            </div>
            <div className="form-group">
              <label>Confirmar Nova Senha</label>
              <input
                type="password"
                placeholder="Repita a senha"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                required
              />
            </div>

            {error && <div className="alert alert-error">{error}</div>}

            <button className="btn btn-primary w-full login-btn" disabled={loading}>
              {loading ? <><span className="spinner" /> Salvando...</> : 'Salvar Nova Senha'}
            </button>
          </form>
        )}

        <p className="login-footer">
          <Link to="/login" style={{ color:'var(--accent)' }}>← Voltar ao login</Link>
          <span className="version-badge">v{VERSION}</span>
        </p>
      </div>
    </div>
  );
}
